export default "__VITE_ASSET__DQfhfjx8__"